export default function setupAxios(axios, store) {
  axios.interceptors.request.use(
    config => {
      // const {
      //   auth: { authToken }
      // } = store.getState();

      const auth = sessionStorage.getItem(`oidc.user:${process.env.REACT_APP_AUTH_URL}:${process.env.REACT_APP_IDENTITY_CLIENT_ID}`);
      let authParse;
      if(auth){
        authParse = JSON.parse(auth);
      }

      if (authParse && authParse.access_token) {
        const authToken = authParse.access_token;
        config.headers.Authorization = `Bearer ${authToken}`;

      }

      //config.headers.AccessControlAllowOrigin = '*';

      return config;
    },
    err => Promise.reject(err)
  );
}
